import styles from './styles/HeaderShortcuts.module.scss';
import {useContext} from "react";
import {StoreContext} from "../../stores/StoreLoader";
import FontAwesome from "../utilities/FontAwesome";
import {conditionType, currentViewType} from "../modals/AdminModal/AdminModalTypes";
import NavigationModel from "../../utils/NavigationModel";
import {runInAction} from "mobx";
import ClickableLink from "../utilities/ClickableLink";
import WatsonApi from "../../backends/WatsonApi";
import {observer} from "mobx-react";
import NotificationManager from "../notifications/NotificationManager";

function Shortcut(props: {
    shortcut: Navigation,
    deleteNavigation: (id: number) => void,
    updateNavigation: (navigation: Navigation) => void,
}) {
    const {userStore} = useContext(StoreContext);

    return <li className={styles.shortcutContainer}>
        {userStore.isEditor && <div className={styles.popup}>
            <div>
                <button title={"Delete Link"} onClick={() => props.deleteNavigation(props.shortcut.id)}>
                    <FontAwesome ariaHidden name={'fa-trash'} prefix={'fas'} />
                </button>
                <button title={"Edit Link"} onClick={() => props.updateNavigation(props.shortcut)}>
                    <FontAwesome ariaHidden name={'fa-pen'} prefix={'fas'} />
                </button>
            </div>
        </div>}
        <ClickableLink href={props.shortcut.url}>
            <FontAwesome fixedWith name={props.shortcut.icon} />
        </ClickableLink>
    </li>
}

export const HeaderShortcuts = observer((props: {
    heroBlock: IHeroTerraceBlock
}) => {
    const {userStore, modalStore} = useContext(StoreContext);

    const navigationCreator = async (navigation) => {
        try {
            const client = await WatsonApi();
            const response = await client.organizations.organizations_navigations_create({
                organization_pk: props.heroBlock.organization_id,
                data: {
                    title: navigation.title,
                    type: 0,
                    external_url: navigation.external_url,
                    icon: navigation.icon,
                    class_field: navigation.class_field,
                    description: navigation.description,
                    path: "",
                    enabled: navigation.enabled,
                    parent: navigation.parent,
                    organization: navigation.organization,
                },
            })
            runInAction(() => {
                props.heroBlock.links.push(JSON.parse(response.data));
            })
        } catch (e) {
            NotificationManager.error("Something went wrong! Please try again.")
        }
    }

    const navigationUpdater = async (navigation) => {
        try {
            const client = await WatsonApi();
            const response = await client.organizations.organizations_navigations_update({
                organization_pk: props.heroBlock.organization_id,
                id: navigation.id,
                data: {
                    title: navigation.title,
                    type: 0,
                    external_url: navigation.external_url,
                    icon: navigation.icon,
                    class_field: navigation.class_field,
                    description: navigation.description,
                    path: "",
                    enabled: navigation.enabled,
                    parent: navigation.parent,
                    organization: navigation.organization,
                },
            })
            runInAction(() => {
                props.heroBlock.links = props.heroBlock.links.map(link => {
                    if (link.id === navigation.id) {
                        return JSON.parse(response.data);
                    }
                    return link;
                })
            })
        } catch (e) {
            NotificationManager.error("Something went wrong! Please try again.")
        }
    }

    const deleteNavigation = async (id) => {
        if (confirm("Are you sure you want to do that?")) {
            try {
                const client = await WatsonApi();
                await client.organizations.organizations_navigations_delete({
                    organization_pk: props.heroBlock.organization_id,
                    id,
                });
                runInAction(() => {
                    props.heroBlock.links = props.heroBlock.links.filter(l => l.id !== id);
                })
            } catch (e) {
                NotificationManager.error("Something went wrong! Please try again.")
            }
        }
    }

    const updateNavigation = (navigation) => {
        modalStore.addModal({
            type: "admin",
            condition: conditionType.EDITING,
            nodeInfo: navigation,
            navigation: [],
            parent: String(props.heroBlock.organization_id),
            navigationUpdater,
        })
    }

    return <div className={styles.container}>
        <ul>
            {userStore.isEditor && <li key={"add"}><button onClick={() => {
                modalStore.addModal({
                    type: "admin",
                    condition: conditionType.ADD_TOPLINK,
                    nodeInfo: new NavigationModel(),
                    navigation: [],
                    parent: String(props.heroBlock.organization_id),
                    initialView:currentViewType.shortcut,
                    navigationCreator,
                })
            }}>
                <FontAwesome name={"fa-plus"} fixedWith prefix={"fas"}/>
            </button></li>}
            {props.heroBlock.links.map(link => {
                return <Shortcut key={link.id} shortcut={link} updateNavigation={updateNavigation} deleteNavigation={deleteNavigation} />
            })}
        </ul>
    </div>
})